import { IApplicationState } from '../../types/redux';
import { dealTypeFromJsonQuery, FDealType } from '../../utils/category';

export function selectIsSutochnoPilotEnabled(state: IApplicationState): boolean {
  const {
    sutochnoPilot: { isPilotEnabled },
    filters: { jsonQuery },
  } = state;

  const dealType = dealTypeFromJsonQuery(jsonQuery);

  // только для посуточной аренды
  return isPilotEnabled && (dealType & FDealType.RentDaily) !== 0;
}
